import React from 'react';
import { JBButton } from '@jbhi-fi/lanyard-ui';
import type { TermsAndConditionsData } from './TermsAndConditionsModal';
import { useTermsAndConditions } from './TermsAndConditionsProvider';

export type TermsAndConditionsLinkProps = {
  termsAndConditions?: TermsAndConditionsData;
  className?: string;
  label?: string;
};

export const TermsAndConditionsLink = ({
  termsAndConditions,
  className,
  label = 'View full T&Cs',
}: TermsAndConditionsLinkProps) => {
  const { openTermsAndConditions } = useTermsAndConditions();

  if (!termsAndConditions) {
    return null;
  }
  const symbol = termsAndConditions.symbol;

  return (
    <>
      {symbol ? <sup className={className}>{symbol}</sup> : null}
      <JBButton
        type="link"
        label={label}
        classes={className}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          openTermsAndConditions(termsAndConditions);
        }}
      />
    </>
  );
};
